import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";

import { Card, Grid, TextField, Select, MenuItem } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import MediaPickerModal from "Main/Modals/MediaModal";

export default class UpdateBatch extends Component {
  state = {
    batch_id: "",
    batch_name: "",
    batch_date: "",
    batch_time: "",
    description: "",
    level_id: "",
    course_id: "",
    batch_file: null,
    img_alt_text: "",
    meta_key: "",
    meta_description: "",
    levels: [],
    courses: [],

    selectedImage: null,
    showMediaModal: false,

    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
    redirect: false,
  };

  componentDidMount() {
    this.getDropdownData();
    this.getSingleBatch();
  }

  // ✅ DROPDOWNS
  getDropdownData = async () => {
    try {
      const [levels, courses] = await Promise.all([
        axios.post(Constants.getUrls.getAllLevels, { page: 1, limit: 100 }),
        axios.post(Constants.getUrls.getAllCourses, { page: 1, limit: 100 }),
      ]);

      this.setState({
        levels: levels.data.data.rows || [],
        courses: courses.data.data.rows || [],
      });
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ GET SINGLE BATCH
  getSingleBatch = async () => {
    const batch_id = window.location.pathname.split("/")[2];

    try {
      const resp = await axios.post(Constants.getUrls.getBatchDetails, {
        id: batch_id,
      });

      console.log(resp);

      if (resp.data.status) {
        const data = resp.data.data;

        this.setState({
          batch_id: data.id,
          batch_name: data.batch_name,
          batch_date: data.batch_date,
          batch_time: data.batch_time,
          description: data.description,
          level_id: data.level_id,
          course_id: data.course_id,
          img_alt_text: data.img_alt_text || "",
          meta_key: data.meta_key || "",
          meta_description: data.meta_description || "",

          // ✅ PREFILL IMAGE
          selectedImage: data.image_id
            ? {
                id: data.image_id,
                image_path: data.image_path,
              }
            : null,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ INPUT
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleFileChange = (e) => {
    this.setState({
      batch_file: e.target.files[0],
    });
  };

  // ✅ UPDATE
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      batch_id,
      batch_name,
      batch_date,
      batch_time,
      description,
      level_id,
      course_id,
      selectedImage,
      img_alt_text,
      meta_key,
      meta_description,
      batch_file,
    } = this.state;

    if (
      !batch_name ||
      !batch_date ||
      !batch_time ||
      !level_id ||
      !course_id ||
      !selectedImage
    ) {
      return this.setState({
        notification: true,
        message: "All fields are required!",
        notiColor: "warning",
      });
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    // ✅ FORM DATA (IMPORTANT)
    const formData = new FormData();

    formData.append("id", batch_id);
    formData.append("batch_name", batch_name);
    formData.append("batch_date", batch_date);
    formData.append("batch_time", batch_time);
    formData.append("description", description);
    formData.append("level_id", level_id);
    formData.append("course_id", course_id);
    formData.append("image_id", selectedImage.id);
    formData.append("role_id", 1);
    formData.append("img_alt_text", img_alt_text);
    formData.append("meta_key", meta_key);
    formData.append("meta_description", meta_description);

    // ✅ FILE APPEND
    if (batch_file) {
      formData.append("files", this.state.batch_file);
    }

    this.setState({ loading: true });

    try {
      const resp = await axios.post(Constants.putUrls.updateBatch, formData);

      this.setState({
        notification: true,
        message: resp.data.message || "Updated successfully!",
        notiColor: "success",
        loading: false,
      });

      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) return <Navigate to="/batch" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card style={{ padding: 20 }}>
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Update Batch
              </MDTypography>
            </MDBox>

            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2} mt={1}>
                {/* NAME */}
                <Grid item sm={6}>
                  <TextField
                    label="Batch Name"
                    name="batch_name"
                    value={this.state.batch_name}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* DATE */}
                <Grid item sm={3}>
                  <TextField
                    type="date"
                    name="batch_date"
                    value={this.state.batch_date}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* TIME */}
                <Grid item sm={3}>
                  <TextField
                    label="Time"
                    name="batch_time"
                    value={this.state.batch_time}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* LEVEL */}
                <Grid item sm={6}>
                  <Select
                    name="level_id"
                    value={this.state.level_id}
                    onChange={this.handleInput}
                    fullWidth
                    style={{ width: "100%", height: "45px", color: "#fff" }}
                    displayEmpty
                  >
                    <MenuItem value="">Select Level</MenuItem>
                    {this.state.levels.map((l) => (
                      <MenuItem key={l.id} value={l.id}>
                        {l.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* COURSE */}
                <Grid item sm={6}>
                  <Select
                    name="course_id"
                    value={this.state.course_id}
                    onChange={this.handleInput}
                    fullWidth
                    style={{ width: "100%", height: "45px", color: "#fff" }}
                    displayEmpty
                  >
                    <MenuItem value="">Select Course</MenuItem>
                    {this.state.courses.map((c) => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.course_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* IMAGE */}
                <Grid item sm={6}>
                  <MDButton
                    variant="contained"
                    onClick={() => this.setState({ showMediaModal: true })}
                  >
                    Change Image
                  </MDButton>

                  {this.state.selectedImage && (
                    <img
                      src={
                        Constants.imageDomain +
                        this.state.selectedImage.image_path
                      }
                      style={{
                        width: 80,
                        height: 80,
                        marginTop: 10,
                        borderRadius: 6,
                      }}
                    />
                  )}
                </Grid>

                {/* ALT TEXT */}
                <Grid item sm={6}>
                  <TextField
                    label="Image Alt Text"
                    name="img_alt_text"
                    value={this.state.img_alt_text}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* META */}
                <Grid item sm={12}>
                  <TextField
                    label="Meta Keywords (SEO)"
                    name="meta_key"
                    value={this.state.meta_key}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                <Grid item sm={12}>
                  <TextField
                    label="Meta Description"
                    name="meta_description"
                    multiline
                    rows={4}
                    value={this.state.meta_description}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* DESC */}
                <Grid item sm={12}>
                  <TextField
                    label="Description"
                    name="description"
                    value={this.state.description}
                    onChange={this.handleInput}
                    multiline
                    rows={4}
                    fullWidth
                  />
                </Grid>
                <Grid item sm={6}>
                  <label>Batch File (PDF/Image)</label>
                  <input type="file" onChange={this.handleFileChange} />
                </Grid>
                {/* SUBMIT */}
                <Grid item sm={12}>
                  <MDButton type="submit" variant="contained" color="info">
                    {this.state.loading ? "Updating..." : "Update Batch"}
                  </MDButton>
                </Grid>
              </Grid>
            </form>
          </Card>

          <MDSnackbar
            color={this.state.notiColor}
            title="Batches"
            content={this.state.message}
            open={this.state.notification}
          />

          {/* MODAL */}
          <MediaPickerModal
            visible={this.state.showMediaModal}
            multiple={false}
            onClose={() => this.setState({ showMediaModal: false })}
            onSelect={(images) => {
              this.setState({
                selectedImage: images[0],
                showMediaModal: false,
              });
            }}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
